module.exports = __webpack_public_path__ + "static/thumb-f54f04d4a863d1d5a3240f4d0f0d6194.png";